import React from "react";
import "../../Styles/footer.css";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer_div relative border-t border-[#062b6c]/40 bg-[#020819] text-slate-100">
      {/* subtle background accents */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-24 top-0 h-40 w-40 rounded-full bg-[#00ad0f]/18 blur-3xl" />
        <div className="absolute right-[-40px] bottom-[-40px] h-56 w-56 rounded-full bg-[#062b6c]/35 blur-3xl" />
      </div>

      <div className="relative">
        <div className="container2">
          <div className="footer_div_area py-10 lg:py-12">
            {/* top content */}
            <div className="grid gap-8 md:grid-cols-[minmax(0,1.4fr)_minmax(0,1.1fr)_minmax(0,0.9fr)]">
              {/* Brand + short text */}
              <div className="space-y-4">
                <div className="footer_div_area_1_cont1">
                  <img
                    src="/logo.webp"
                    alt="Scaftech logo"
                    className="header_div_area_cont1_img w-40 md:w-44"
                  />
                </div>
                <p className="text-sm leading-relaxed text-slate-300">
                  Scaftech Engineering Services delivers certified engineering,
                  lifting, inspection, and training solutions to Oil &amp; Gas,
                  Marine, and Construction industries across Nigeria and beyond.
                </p>
              </div>

              {/* Contact */}
              <div className="footer_div_area_1_cont2">
                <div className="footer_div_area_1_cont2_title mb-3 text-sm font-semibold uppercase tracking-[0.22em] text-[#e4ffe9]">
                  Contact
                </div>
                <div className="footer_div_area_1_cont2_body space-y-2 text-sm text-slate-200">
                  <div className="footer_div_area_1_cont2_body_div1">
                    27/28 Ringback Mall, Mobil filling station complex, Km 36
                    Lekki - Epe Expy, express 100001, Lagos.
                  </div>
                  <div className="footer_div_area_1_cont2_body_div1">
                    <a
                      href="tel:+2348161637797"
                      className="hover:text-[#7fffb0]"
                    >
                      +234-816-163-7797
                    </a>
                    {", "}
                    <a
                      href="tel:+2348112627647"
                      className="hover:text-[#7fffb0]"
                    >
                      +234-811-262-7647
                    </a>
                  </div>
                  <div className="footer_div_area_1_cont2_body_div1">
                    <a
                      href="mailto:consult@scaftechservices.com"
                      className="hover:text-[#7fffb0]"
                    >
                      consult@scaftechservices.com
                    </a>
                  </div>
                </div>
              </div>

              {/* Quick links + social */}
              <div className="space-y-4">
                <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#e4ffe9]">
                  Navigate
                </div>
                <nav className="space-y-2 text-sm text-slate-300">
                  <a href="/who-we-are" className="block hover:text-[#7fffb0]">
                    Who We Are
                  </a>
                  <a href="/services" className="block hover:text-[#7fffb0]">
                    Services
                  </a>
                  <a
                    href="/certification"
                    className="block hover:text-[#7fffb0]"
                  >
                    Certifications &amp; Awards
                  </a>
                  <a href="/contact-us" className="block hover:text-[#7fffb0]">
                    Contact Us
                  </a>
                </nav>

                <div className="mt-4">
                  <p className="mb-2 text-xs font-semibold uppercase tracking-[0.22em] text-slate-400">
                    Connect
                  </p>
                  <div className="flex items-center gap-3">
                    <a
                      href="https://www.facebook.com/Scaftechengineeringservices"
                      target="_blank"
                      rel="noreferrer"
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 bg-white/5 text-xs hover:border-[#00ad0f] hover:text-[#00ad0f]"
                      aria-label="Scaftech on Facebook"
                    >
                      f
                    </a>
                    <a
                      href="https://www.linkedin.com/in/scaftech-engineering-services-61aaa0255/overlay/about-this-profile/"
                      target="_blank"
                      rel="noreferrer"
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 bg-white/5 text-xs hover:border-[#00ad0f] hover:text-[#00ad0f]"
                      aria-label="Scaftech on LinkedIn"
                    >
                      in
                    </a>
                    <a
                      href="https://www.youtube.com/@scaftech_nigeria"
                      target="_blank"
                      rel="noreferrer"
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 bg-white/5 text-xs hover:border-[#00ad0f] hover:text-[#00ad0f]"
                      aria-label="Scaftech on YouTube"
                    >
                      ▶
                    </a>
                    <a
                      href="https://www.instagram.com/scaftech.ng/"
                      target="_blank"
                      rel="noreferrer"
                      className="flex h-8 w-8 items-center justify-center rounded-full border border-white/15 bg-white/5 text-xs hover:border-[#00ad0f] hover:text-[#00ad0f]"
                      aria-label="Scaftech on Instagram"
                    >
                      ◦
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <hr className="footer_hr my-6 border-[#1e293b]" />

            {/* bottom bar */}
            <div className="footer_lastDiv flex flex-col items-center justify-between gap-3 text-xs text-slate-400 md:flex-row">
              <div>© {currentYear} Scaftech Nigeria. All rights reserved.</div>
              <div className="flex flex-wrap items-center gap-3">
                <span>ISO-oriented engineering &amp; training partner.</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
